import { Handle, NodeProps, Position } from 'reactflow'
import {
  TbBolt,
  TbCircleArrowUpRight,
  TbDatabase,
  TbQuestionMark,
} from 'react-icons/tb'
import { IntegrationElementType, ScenarioElement } from '@integration-app/sdk'
import classes from './nodeStyles.module.scss'

export const SCENARIO_ELEMENT_NODE_WIDTH = 178
export const SCENARIO_ELEMENT_NODE_HEIGHT = 40

export function ScenarioElementNode(props: NodeProps<ScenarioElement>) {
  const scenarioElement = props.data ?? {}
  const { type, element } = scenarioElement

  return (
    <div
      style={{
        width: SCENARIO_ELEMENT_NODE_WIDTH,
        height: SCENARIO_ELEMENT_NODE_HEIGHT,
      }}
      className={classes.scenarioElement}
    >
      <Handle
        type='source'
        position={Position.Left}
        style={{
          background: 'transparent',
        }}
      ></Handle>
      <Handle
        type='target'
        position={Position.Right}
        style={{
          background: 'transparent',
        }}
      ></Handle>

      <Icon type={type} />

      <span className={classes.scenarioElement_text} title={element.name}>
        {element.name}
      </span>
    </div>
  )
}

function Icon({ type }: { type: IntegrationElementType }) {
  const Icon = getIcon(type)
  return (
    <div className={classes.scenarioElement_icon}>
      <Icon />
    </div>
  )
}

function getIcon(type: IntegrationElementType) {
  switch (type) {
    case IntegrationElementType.ACTION:
      return TbCircleArrowUpRight
    case IntegrationElementType.FLOW:
      return SvgIconFlow
    case IntegrationElementType.FIELD_MAPPING:
      return SvgIconFieldMapping
    case IntegrationElementType.DATA_SOURCE:
      return TbDatabase
    case IntegrationElementType.APP_EVENT_TYPE:
      return TbBolt
    case IntegrationElementType.DATA_LINK_TABLE:
      return SvgIconDataSchema
    default:
      console.error(
        `Unknown integration element type: ${type}, using question mark icon.`,
      )
      return TbQuestionMark
  }
}
function SvgIconFlow({ ...props }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox={'0 0 20 20'}
      fill='none'
      stroke={'currentColor'}
      {...props}
    >
      <path d='M14.5 12.8v-.777a2 2 0 0 0-2-2h-5a2 2 0 0 0-2 2v.778m4.512-5.5v2.826M12 3H8a1 1 0 0 0-1 1v1.6a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1ZM7.5 13.5h-4a1 1 0 0 0-1 1v1.6a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-1.6a1 1 0 0 0-1-1ZM16.5 13.5h-4a1 1 0 0 0-1 1v1.6a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-1.6a1 1 0 0 0-1-1Z' />
    </svg>
  )
}
function SvgIconFieldMapping({ ...props }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox={'0 0 20 20'}
      fill='none'
      stroke={'currentColor'}
      {...props}
    >
      <path d='M7.3 12h-4a1 1 0 0 0-1 1v1.6a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V13a1 1 0 0 0-1-1ZM12 13.7H8M16.7 12h-4a1 1 0 0 0-1 1v1.6a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V13a1 1 0 0 0-1-1ZM7.3 4.5h-4a1 1 0 0 0-1 1v1.6a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V5.5a1 1 0 0 0-1-1ZM8 6.3h4M16.7 4.5h-4a1 1 0 0 0-1 1v1.6a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V5.5a1 1 0 0 0-1-1Z' />
    </svg>
  )
}
function SvgIconDataSchema({ ...props }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox={'0 0 20 20'}
      fill='none'
      {...props}
    >
      <path
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M18 10.022a2 2 0 1 0-4 0 2 2 0 0 0 4 0ZM6 15.02a2 2 0 1 0-4 0 2 2 0 0 0 4 0ZM6 5.021a2 2 0 1 0-4 0 2 2 0 0 0 4 0ZM6 15.022h2a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2H6M10 10.021h4'
      />
    </svg>
  )
}
